<template>
    <ion-page style="overflow: auto">
        <div>
            <fis-header></fis-header>
            <div class="container-fluid" id="itenary-div" style="height: 100% !important;">
                <div class="row">
                    <div class="col-sm-12" id="top-margin"></div>
                </div>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="ml-5" id="breadcrums-info">
                        <bread-crumbs v-bind:crumbs="breadCrumbs"></bread-crumbs>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="row" style="padding-top: 20px;">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-7" id="info-panel">
                        <div v-html="pageContent"></div>
                    </div>

                    <sponsors-page :total-sponsors="6" class="mt-n1"></sponsors-page>
                </div>

                <div class="row town-explore-row" style="margin-top: 30%" v-if="loaded">
                    <div class="col-sm-12">
                        <div class="row" id="topics-info">
                            <div class="col-sm-8"></div>
                            <div class="col-12 col-sm-3 town-explore-col">
                                <div class="town-explore-card">
                                    <p class="town-explore-title">Explore in this area</p>
                                    <div class="town-explore-triggers">
                                        <div class="d-flex position-relative town-explore-item">
                                            <button
                                                type="button"
                                                class="town-explore-btn"
                                                :class="{ 'town-explore-btn-open': isFestivalOpen }"
                                                @click="festivalMenu"
                                                aria-haspopup="true"
                                                :aria-expanded="isFestivalOpen"
                                            >
                                                <span class="town-explore-icon">🎉</span>
                                                <span class="town-explore-label">Festivals</span>
                                                <span class="submenu-plus" :class="{ 'submenu-plus-open': isFestivalOpen }">+</span>
                                            </button>
                                            <div class="town-dropdown-wrap" :class="{ show: isFestivalOpen }">
                                                <ul class="town-dropdown">
                                                    <li v-for="(festival, index) in festivals" :key="index">
                                                        <router-link :to="pageRouteLink(festival.link)" class="town-dropdown-link" active-class="active-submenu">
                                                            {{ festival.page_name }}
                                                        </router-link>
                                                    </li>
                                                    <li v-if="!festivals.length" class="town-dropdown-empty">No festivals listed yet.</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="d-flex position-relative town-explore-item">
                                            <button
                                                type="button"
                                                class="town-explore-btn"
                                                :class="{ 'town-explore-btn-open': isNewsOpen }"
                                                @click="newsMenu"
                                                aria-haspopup="true"
                                                :aria-expanded="isNewsOpen"
                                            >
                                                <span class="town-explore-icon">📰</span>
                                                <span class="town-explore-label">News</span>
                                                <span class="submenu-plus" :class="{ 'submenu-plus-open': isNewsOpen }">+</span>
                                            </button>
                                            <div class="town-dropdown-wrap" :class="{ show: isNewsOpen }">
                                                <ul class="town-dropdown">
                                                    <li v-for="(nw, index) in news" :key="index">
                                                        <router-link :to="pageRouteLink(nw.link)" class="town-dropdown-link" active-class="active-submenu">
                                                            {{ nw.page_name }}
                                                        </router-link>
                                                    </li>
                                                    <li v-if="!news.length" class="town-dropdown-empty">No news listed yet.</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="d-flex position-relative town-explore-item">
                                            <button
                                                type="button"
                                                class="town-explore-btn"
                                                :class="{ 'town-explore-btn-open': isEventOpen }"
                                                @click="eventMenu"
                                                aria-haspopup="true"
                                                :aria-expanded="isEventOpen"
                                            >
                                                <span class="town-explore-icon">📅</span>
                                                <span class="town-explore-label">Events</span>
                                                <span class="submenu-plus" :class="{ 'submenu-plus-open': isEventOpen }">+</span>
                                            </button>
                                            <div class="town-dropdown-wrap" :class="{ show: isEventOpen }">
                                                <ul class="town-dropdown">
                                                    <li v-for="(event, index) in events" :key="index">
                                                        <router-link :to="pageRouteLink(event.link)" class="town-dropdown-link" active-class="active-submenu">
                                                            {{ event.page_name }}
                                                        </router-link>
                                                    </li>
                                                    <li v-if="!events.length" class="town-dropdown-empty">No events listed yet.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <fis-footer></fis-footer>
        </div>
    </ion-page>
</template>
<script lang="ts">

import {defineComponent} from "vue";
import fisHeader from "@/components/fisHeader.vue";
import fisFooter from "@/components/fisFooter.vue";
import axios from "@/axios";
import {IonPage} from "@ionic/vue";
import SponsorsPage from "@/components/sponsorsPage.vue";
import {Navigation} from "swiper";

import 'swiper/css';
import '@ionic/vue/css/ionic-swiper.css';
import "swiper/css/navigation";
import BreadCrumbs from "@/components/breadCrumbs.vue";
import {mapActions, mapGetters} from "vuex";

export default defineComponent({
    name: "StandardPage",
    components: {BreadCrumbs, SponsorsPage, fisHeader, fisFooter, IonPage},
    computed: {
        ...mapGetters({
            getEvents: 'pages/getEvents',
            getNews: 'pages/getNews',
            getFestivals: 'pages/getFestivals'
        }),
    },
    setup() {
        return {
            modules: [Navigation],
        };
    },
    methods: {
        ...mapActions({
            fetchNews: "pages/fetchNews",
            fetchEvents: "pages/fetchEvents",
            fetchFestivals: "pages/fetchFestivals"
        }),
        festivalMenu() {
            this.isFestivalOpen = !this.isFestivalOpen;
            this.isNewsOpen = false;
            this.isEventOpen = false;
        },
        newsMenu() {
            this.isNewsOpen = !this.isNewsOpen;
            this.isEventOpen = false;
            this.isFestivalOpen = false;
        },
        eventMenu() {
            this.isEventOpen = !this.isEventOpen;
            this.isNewsOpen = false;
            this.isFestivalOpen = false;
        },
        normalizePageLink(rawLink: any) {
            const value = decodeURIComponent((rawLink || '').toString()).trim().replace(/^#/, '');
            return value
                .toLowerCase()
                .replace(/[^a-z0-9\s-]/g, '')
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-')
                .replace(/^-|-$/g, '');
        },
        pageRouteLink(rawLink: any) {
            const slug = this.normalizePageLink(rawLink);
            return `/page/${slug}`;
        },
        async fetchPageByAnySupportedLink(link: string) {
            const candidates = [link, `#${link}`];
            for (const candidate of candidates) {
                try {
                    const apiPath = encodeURIComponent(candidate);
                    const response = await axios.get("/blog/page/" + apiPath);
                    return response;
                } catch (error: any) {
                    if (error?.response?.status !== 404) {
                        throw error;
                    }
                }
            }
            throw new Error('Page not found');
        },
        extractCityPageTitle(html: string): string {
            if (!html) return '';
            try {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const el = doc.querySelector('h1, h2, h3, h4, strong');
                return el ? (el.textContent || '').trim() : '';
            } catch {
                return '';
            }
        },
        async fetchData() {
            const citySlugs = ['adelaide', 'brisbane', 'canberra', 'darwin', 'hobart', 'melbourne', 'perth', 'sydney'];
            let link = this.normalizePageLink(this.$route.params.link);

            // Backward compatibility for old /page/#... links
            if (!link && window.location.hash && window.location.hash.length > 1) {
                link = this.normalizePageLink(window.location.hash.substring(1));
                if (link) {
                    this.$router.replace({path: `/page/${link}`});
                }
            }
            
            // Only make API call if we have a link
            if (link) {
                try {
                    const response = await this.fetchPageByAnySupportedLink(link);
                    // console.log(response.data.town.id);
                    this.pageContent = response.data.page.description
                    this.breadCrumbs = this.createBreadCrumbs(response.data);
                    // For capital city pages: append the first heading/strong from the page HTML
                    if (citySlugs.includes(link)) {
                        const pageTitle = this.extractCityPageTitle(response.data.page.description);
                        if (pageTitle) {
                            this.breadCrumbs = `${this.breadCrumbs} > ${pageTitle}`;
                        }
                    }
                    if (response.data.town !== null) {
                        this.loaded = true;
                        this.town = response.data.town.id;
                       await this.fetchEvents(this.town);
                        this.events = this.getEvents;
                       await this.fetchNews(this.town);
                        this.news = this.getNews;
                        await this.fetchFestivals(this.town);
                        this.festivals = this.getFestivals;
                    }
                } catch (error) {
                    console.error('Error fetching page data:', error);
                    // Set default content if API fails
                    this.pageContent = '';
                    this.loaded = false;
                }
            } else {
                // No link provided, set default state
                this.pageContent = '';
                this.loaded = false;
            }
        },
        createBreadCrumbs(data) {
            const levels = ["country", "state", "region", "shire", "town"];
            const geoTrail = levels
                .filter(level => data[level])
                .map(level => data[level]['name']);

            const hasNoSubLocation = !data.state && !data.region && !data.shire && !data.town;
            const pageName = data?.page?.page_name;
            const pageType = data?.page?.page_type;
            // The route is the canonical page identifier. Some older API records use
            // legacy link values that do not match the homepage's current topic URLs.
            const rawLink = this.$route.params.link || data?.page?.link || '';
            const normalizedLink = decodeURIComponent(rawLink.toString())
                .trim()
                .replace(/^#/, '')
                .toLowerCase();
            const aboutSlugs = ['who-we-are', 'what-we-do'];
            const formattedLinkName = normalizedLink
                .replace(/-/g, ' ')
                .replace(/\b\w/g, (char) => char.toUpperCase());
            const formattedPageName = (pageName || '')
                .toString()
                .trim()
                .replace(/[-_]/g, ' ')
                .replace(/\b\w/g, (char) => char.toUpperCase());

            const capitalCityTrails: Record<string, string[]> = {
                adelaide: [
                    'Australia',
                    'South Australia',
                    'Adelaide City Centre',
                    'Adelaide City Council',
                    'Adelaide'
                ],
                brisbane: [
                    'Australia',
                    'Queensland',
                    'Brisbane City Centre',
                    'Brisbane City Council',
                    'Brisbane'
                ],
                canberra: [
                    'Australia',
                    'Australian Capital Territory',
                    'Canberra Capital',
                    'ACT Government',
                    'Canberra'
                ],
                darwin: [
                    'Australia',
                    'Northern Territory',
                    'Darwin City Centre',
                    'Darwin City Council',
                    'Darwin'
                ],
                hobart: [
                    'Australia',
                    'Tasmania',
                    'Hobart City Centre',
                    'Hobart City Council',
                    'Hobart'
                ],
                melbourne: [
                    'Australia',
                    'Victoria',
                    'Melbourne City Centre',
                    'Melbourne City Council',
                    'Melbourne'
                ],
                perth: [
                    'Australia',
                    'Western Australia',
                    'Perth City Centre',
                    'Perth City Council',
                    'Perth'
                ],
                sydney: [
                    'Australia',
                    'New South Wales',
                    'Sydney City Centre',
                    'Sydney City Council',
                    'Sydney'
                ]
            };

            if (capitalCityTrails[normalizedLink]) {
                return capitalCityTrails[normalizedLink].join(' > ');
            }

            const sectorTopicSlugs = [
                'australian-treasures',
                'cultural-heritage-trails',
                'hiking-trails',
                'historic-landmarks',
                'lakes',
                'lookouts',
                'national-parks',
                'natural-wonders',
                'rail-trails-cycling-tracks',
                'scenic-drives',
                'secret-hideaways',
                'waterfalls-cascading-wonders',
                'waterways-walking-trails',
                'wetlands-wonderlands',
                'wildlife-experiences'
            ];

            if (sectorTopicSlugs.includes(normalizedLink)) {
                return ['Australia', 'Sector Topics', 'Tourism', formattedLinkName].join(' > ');
            }

            // For top-level About pages, show semantic breadcrumbs even without geo hierarchy.
            if (hasNoSubLocation && aboutSlugs.includes(normalizedLink)) {
                const countryName = data?.country?.name || 'Australia';
                return [countryName, 'About Us', formattedPageName || formattedLinkName].filter(Boolean).join(' > ');
            }

            // For Festivals / News / Events pages: Town > Festivals|News|Events > Page name
            const categoryByType: Record<string, string> = {
                'FestivalPages': 'Festivals',
                'NewsPages': 'News',
                'EventPages': 'Events'
            };
            const category = pageType ? categoryByType[pageType] : null;
            if (category && formattedPageName) {
                return [...geoTrail, category, formattedPageName].filter(Boolean).join(' > ');
            }

            // City pages: have country + state in geo trail → append slug city name + page title
            if (formattedPageName && geoTrail.length >= 2) {
                const trailEnd = geoTrail[geoTrail.length - 1] || '';
                if (
                    formattedLinkName &&
                    formattedLinkName.toLowerCase() !== trailEnd.toLowerCase() &&
                    formattedLinkName !== formattedPageName
                ) {
                    return [...geoTrail, formattedLinkName, formattedPageName].filter(Boolean).join(' > ');
                }
                return [...geoTrail, formattedPageName].filter(Boolean).join(' > ');
            }

            return geoTrail.join(' > ');
        },
        handleHashChange() {
            // Handle hash change with a small delay to ensure hash is set
            setTimeout(() => {
                this.fetchData();
            }, 100);
        }
    },
    watch: {
        '$route'(to, from) {
            // Re-fetch data when route changes
            this.$nextTick(() => {
                this.fetchData();
            });
        }
    },
    mounted() {
        window.addEventListener('hashchange', this.handleHashChange);
        this.fetchData();
    },
    beforeUnmount() {
        // Clean up event listener
        window.removeEventListener('hashchange', this.handleHashChange);
    },
    data() {
        return {
            breadCrumbs: '',
            town: '',
            pageContent: '',
            loaded: false,
            isFestivalOpen: false,
            isNewsOpen: false,
            isEventOpen: false,
            festivals: [],
            events: [],
            news: []
        }
    }
})

</script>

<style scoped>
/* Card column: same width as sponsors (col-sm-3), full width on small screens */
.town-explore-col {
    width: 100%;
}

.town-explore-card {
    margin-top: 0;
    background: linear-gradient(145deg, #ffffff 0%, #f6f8fa 100%);
    border-radius: 14px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.06);
    padding: 1.1rem 1.25rem;
    width: 100%;
}

/* Ultrawide: pull card up to reduce gap (row still has margin-top: 30%) */
@media (min-width: 2560px) {
    .town-explore-card {
        margin-top: -22rem;
    }
}

.town-explore-title {
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: rgba(0, 0, 0, 0.5);
    margin: 0 0 1rem 0;
}

.town-explore-triggers {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.town-explore-item {
    margin-bottom: 0.25rem;
    position: relative;
}

.town-explore-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.65rem 1rem;
    font-size: 1rem;
    font-weight: 500;
    color: #1a1d21;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    cursor: pointer;
    text-align: left;
    transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
    white-space: nowrap;
}

.town-explore-btn:hover {
    background: #f8f9fa;
    border-color: rgba(52, 170, 222, 0.25);
    box-shadow: 0 2px 8px rgba(52, 170, 222, 0.08);
}

.town-explore-btn-open {
    background: rgba(52, 170, 222, 0.08);
    border-color: rgba(52, 170, 222, 0.35);
    box-shadow: 0 2px 12px rgba(52, 170, 222, 0.12);
}

.town-explore-icon {
    font-size: 1.15em;
    line-height: 1;
}

.town-explore-label {
    flex: 1;
}

.submenu-plus {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.25rem;
    height: 1.25rem;
    font-size: 1.1em;
    font-weight: 600;
    line-height: 1;
    color: rgba(0, 0, 0, 0.5);
    transition: transform 0.25s ease, color 0.2s ease;
}

.town-explore-btn:hover .submenu-plus {
    color: #34aade;
}

.submenu-plus-open {
    transform: rotate(45deg);
    color: #34aade;
}

.town-dropdown-wrap {
    position: absolute;
    left: 0;
    top: 100%;
    margin-top: 0.35rem;
    width: 100%;
    min-width: 100%;
    max-height: 280px;
    overflow: hidden;
    visibility: hidden;
    opacity: 0;
    transform: translateY(-6px);
    transition: visibility 0.2s ease, opacity 0.2s ease, transform 0.2s ease;
    z-index: 20;
}

.town-dropdown-wrap.show {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
}

.town-dropdown {
    list-style: none;
    margin: 0;
    padding: 0.4rem 0;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(0, 0, 0, 0.08);
    overflow-y: auto;
    max-height: 260px;
}

.town-dropdown li {
    margin: 0;
    padding: 0;
    border: none;
}

.town-dropdown-link {
    display: block;
    padding: 0.7rem 1.25rem;
    font-size: 0.9rem;
    color: #2c3e50;
    text-decoration: none;
    transition: background 0.15s ease, color 0.15s ease;
    border-left: 3px solid transparent;
}

.town-dropdown-link:hover {
    background: rgba(52, 170, 222, 0.08);
    color: #1a1d21;
    border-left-color: #34aade;
}

.town-dropdown-link.active-submenu {
    background: rgba(52, 170, 222, 0.12);
    color: #34aade;
    font-weight: 600;
    border-left-color: #34aade;
}

.town-dropdown-link.active-submenu:hover {
    background: #34aade;
    color: #fff;
    border-left-color: #34aade;
}

.town-dropdown-empty {
    padding: 1rem 1.25rem;
    font-size: 0.85rem;
    color: rgba(0, 0, 0, 0.45);
    font-style: italic;
}

@media (max-width: 575.98px) {
    .town-explore-card {
        padding: 1rem;
        border-radius: 12px;
    }
    .town-explore-btn {
        padding: 0.75rem 1rem;
        font-size: 0.95rem;
    }
    .town-dropdown-wrap {
        position: relative;
        margin-top: 0.5rem;
    }
    .town-dropdown-wrap.show {
        margin-bottom: 0.5rem;
    }
}
</style>
